import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import Button from "@irati/ui/src/Button"
import padding from "@irati/ui/src/global/padding"
import HasPermissionTo from "@irati/utils/permissions/HasPermissionTo"
import {FormattedMessage} from "@irati/utils/lang"

import UpArrow from "../../../images/icons/upArrow.svg"
import DownArrow from "../../../images/icons/downArrow.svg"
import FlexWrapper from "../../ui/Layout/FlexWrapper"
import {COLOR_DARK_GREEN, COLOR_DARK_RED} from "../../utils/constants/heatmap"

const StyledWrapper = styled(FlexWrapper)`
  margin-bottom: ${padding.tiny};
`

const Icon = styled.img`
  background: ${({color}) => color};
  padding: 5px;
  border-radius: 50%;
  margin-right: 10px;
`

const TextWrapper = styled.div`
  margin-right: 10px;
`
const Toggle = ({onClick, active}) => {
  return (
    <HasPermissionTo permissions={["insights.changeOverTime"]} Error={null}>
      <StyledWrapper align="center" justify="space-between">
        <Icon color={COLOR_DARK_GREEN} src={UpArrow} alt="" size={20} />
        <Icon color={COLOR_DARK_RED} src={DownArrow} alt="" size={20} />
        <TextWrapper> <FormattedMessage id="insights.heatmap.cot.toggleText" /> </TextWrapper>
        <Button small onClick={onClick}>
          {active ? <FormattedMessage id="insights.heatmap.cot.hide" /> : <FormattedMessage id="insights.heatmap.cot.show" />}
        </Button>
      </StyledWrapper>
    </HasPermissionTo>
  )
}

Toggle.propTypes = {
  onClick: PropTypes.func,
  active: PropTypes.bool
}
Toggle.defaultProps = {
  onClick: () => null,
  active: false
}

export default Toggle
